$(document).ready(function() {

	// text areas with character count hint below component
	// <div class="FormFieldHint FormFieldWordCount govuk-hint">...
	$('textarea').each(


		function() {

			var textareaID = $(this).attr('id'),
				maxlength = $(this).attr('maxlength'),
				// merge the ID to the longer class definition
				// see DOM : <div class="FormFieldHint FormFieldWordCount govuk-hint"><p aria-live="polite" id=" $fieldLabelID -num-current"> $fieldCharacterCountString </p></div>
				current = $('#' + textareaID + '-num-current');

			// set the FormFieldWordCount string
			var lengthLoad = $(this).val().length;

			// first render in the onload
			if(lengthLoad > 1) {

				// any textareas with some text

				var countLeft = maxlength - lengthLoad,
					countPercent = lengthLoad / maxlength * 100;

				if(countLeft == 1) {

					current.text('You have ' + countLeft + ' character remaining');
					current.css('font-weight', 'normal');

				} else if(countLeft == 0) {

					current.text('You have no characters remaining');
					current.addClass('govuk-error-message');
					current.css('font-weight', 'bold');

				} else {

					current.text('You have ' + countLeft + ' characters remaining');
					current.css('font-weight', 'normal');
					current.removeClass('govuk-error-message');

				}

				/* This creates warning text colour when it's nearing the limit */
				if(countPercent > 70) {

					current.addClass('count-warning');

				}
				if(countPercent < 70) {

					current.removeClass('count-warning');

				}


			} else {

				// empty textareas
				$(current).text('You have ' + maxlength + ' characters remaining');

			}


			// count the live updates to a textarea with maxlength attribute set
			$(this).keyup(function() {

				var characterCount = $(this).val().length,
					countLeft = maxlength - characterCount;
				countPercent = characterCount / maxlength * 100;

				if(countLeft == 1) {

					current.text('You have ' + countLeft + ' character remaining');
					current.css('font-weight', 'normal');

				} else if(countLeft == 0) {

					current.text('You have no characters remaining');
					current.addClass('govuk-error-message');
					current.css('font-weight', 'bold');

				} else {

					current.text('You have ' + countLeft + ' characters remaining');
					current.css('font-weight', 'normal');
					current.removeClass('govuk-error-message');

				}

				/* This creates warning text colour when it's nearing the limit */
				if(countPercent > 70) {

					current.addClass('count-warning');

				}
				if(countPercent < 70) {

					current.removeClass('count-warning');

				}



			});


		}

	);

});